// extracted by mini-css-extract-plugin
export default {"pendingHolder":"Pending_pendingHolder__BssH6","scale-down-center":"Pending_scale-down-center__psIbL"};